import { formatFileSize } from '../../UploadDocuments/utils';

const slugify = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

// const getExtension = (fileName = '') => {
//   const parts = fileName.split('.');
//   return parts.length > 1 ? parts.pop().toLowerCase() : '';
// };

const getExtension = (mimeType = '', fileName = '') => {
  if (mimeType) {
    return mimeType.split('/').pop().toLowerCase();
  }

  const parts = fileName.split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

// Converts the flat pdfArray (each with documentPath like
// "Councilpdf/form21.pdf") into folder + file items for the Explorer,
// synthesizing a folder node for every unique path segment.
export const buildDriveItemsFromPdfArray = (pdfArray = []) => {
  const folderMap = new Map(); // full path -> folder item
  const items = [];

  const ensureFolderChain = (folderParts) => {
    let parentId = 'root';
    let pathSoFar = '';

    folderParts.forEach((part) => {
      pathSoFar = pathSoFar ? `${pathSoFar}/${part}` : part;

      if (!folderMap.has(pathSoFar)) {
        const folderItem = {
          id: `folder-${slugify(pathSoFar)}`,
          parentId,
          type: 'folder',
          name: part,
          modified: '--',
          size: '--',
          status: 'Ready',
        };
        folderMap.set(pathSoFar, folderItem);
        items.push(folderItem);
      }

      parentId = folderMap.get(pathSoFar).id;
    });

    return parentId;
  };

  pdfArray.forEach((pdf) => {
    const fullPath = pdf.documentPath || pdf.documentName || '';
    const parts = fullPath.split('/').filter(Boolean);
    const fileName = pdf.documentName || parts[parts.length - 1] || 'Untitled';
    const folderParts = parts.slice(0, -1);
    const parentId = ensureFolderChain(folderParts);

    items.push({
      id: pdf.documentId,
      parentId,
      type: 'file',
      name: fileName,
      extension: getExtension(pdf.type, fileName),
      modified: '--',
      size: pdf.size ? formatFileSize(pdf.size) : '--',
      status: 'Ready',
      documentId: pdf.documentId,
      documentPath: pdf.documentPath,
      mimeType: pdf.type,
    });
  });

  return items;
};
